import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { ICostCenter } from '../../interfaces/cost-center';
import { NgbDropdown } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'group-select',
  styleUrls: ['../../pages/reports/reports.component.scss', './group-select.component.scss'],
  template: `
      <div class="group-filter fade-in-animation">
          <div ngbDropdown class="d-inline-block" #myDrop="ngbDropdown">
              <div class="btn btn-outline-primary" id="dropdownGroups" ngbDropdownToggle>
                  <div class="dropdown-label">Grupo</div>
                  <div class="selected-items" *ngIf="!selectedGroups.length">Todos</div>
                  <div class="selected-items" *ngIf="selectedGroups.length">
                      {{selectedGroups.length}} {{selectedGroups.length > 1 ? 'grupos selecionados' : 'grupo selecionado'}}
                  </div>
              </div>

              <ul ngbDropdownMenu aria-labelledby="dropdownGroups">
                  <li class="colab-checkbox"
                      *ngFor="let group of groups" [class.disabled]="selectedGroups.includes('all')"
                      (click)="onGroupSelect(group.id)">
                      <input type="checkbox"
                             [checked]="selectedGroups.includes(group.id)"
                             [value]="group.id"
                             [id]="group.id"
                             [name]="group.name">
                      <label [for]="group.id" (click)="onGroupSelect(group.id)">{{group.name}}</label>
                  </li>
              </ul>
          </div>
      </div>
  `
})
export class GroupSelectComponent implements OnInit {

  @Input() set selected(selected: string | string[]) {
    this.selectedGroups = (typeof selected === 'string') ? [] : selected;
  }

  @Output() selectGroup: EventEmitter<string | string[]> = new EventEmitter();

  @ViewChild('myDrop') myDrop: NgbDropdown;

  @Input() groups: ICostCenter[] = [];

  selectedGroups: string[] = [];

  ngOnInit() {}

  onGroupSelect(value) {
    if (!this.selectedGroups.includes(value)) {
      this.selectedGroups.push(value);
    } else if (this.selectedGroups.includes(value)) {
      this.selectedGroups = this.selectedGroups.filter(el => el !== value);
    }

    this.selectGroup.emit(!this.selectedGroups.length ? 'all' : this.selectedGroups);
  }


}
